<template>
    <div
        class="align-center column"
        :style="{ width: imageSize + 'px' }"
        @click="handleClick"
        style="cursor: pointer"
    >
        <img
            :src="imageSrc"
            :alt="imageAlt"
            :style="{
                marginBottom: imageTextGap + 'px',
                width: imageSize + 'px',
                height: imageSize + 'px',
            }"
        />
        <p :style="textStyle">{{ textContent }}</p>
    </div>
</template>

<script>
import { defineComponent } from "vue";

import { useRoute } from "vue-router";

export default defineComponent({
    props: {
        imageSrc: String,
        imageAlt: {
            type: String,
            default: "Image",
        },
        imageSize: {
            type: Number,
            default: 115,
        },
        textContent: String,
        textStyle: Object,
        imageTextGap: {
            type: Number,
            default: 10, // 기본 간격을 10px로 설정
        },
        destination: {
            type: String,
            default: "",
        },
    },
    setup(props) {
        // 클릭 이벤트 핸들러
        const handleClick = () => {
            if (props.onClick) {
                props.onClick(); // 부모 컴포넌트에서 제공한 클릭 이벤트 핸들러 실행
            }
        };

        const route = useRoute();

        return {
            handleClick,
            route,
        };
    },
});
</script>

<style scoped>
img {
    width: 100%; /* 이미지 너비를 컴포넌트에 맞춤 */
}
</style>
